// Microsoft Fluent Emoji CDN Configuration
// Uses the official Fluent Emoji repository assets

// CDN base URL for Fluent Emoji 3D assets (static)
export const FLUENT_EMOJI_CDN = 'https://raw.githubusercontent.com/microsoft/fluentui-emoji/main/assets'

// CDN base URL for Fluent Emoji Animated assets
// Using GitHub's media.githubusercontent.com which properly serves Git LFS files
// https://github.com/microsoft/fluentui-emoji-animated
export const FLUENT_EMOJI_ANIMATED_CDN = 'https://media.githubusercontent.com/media/microsoft/fluentui-emoji-animated/main/assets'

// Map emoji characters to their Fluent Emoji asset paths
// Using 3D style for the best visual appearance
export const EMOJI_MAP: Record<string, string> = {
  // Navigation
  '🏠': 'House/3D/house_3d.png',
  '👥': 'Busts in silhouette/3D/busts_in_silhouette_3d.png',
  '🛒': 'Shopping cart/3D/shopping_cart_3d.png',
  '👤': 'Bust in silhouette/3D/bust_in_silhouette_3d.png',
  '⚙️': 'Gear/3D/gear_3d.png',
  '⚙': 'Gear/3D/gear_3d.png', // Without variant selector
  
  // Stats & Logo
  '🔥': 'Fire/3D/fire_3d.png',
  '💎': 'Gem stone/3D/gem_stone_3d.png',
  '🧭': 'Compass/3D/compass_3d.png',
  '🛡️': 'Shield/3D/shield_3d.png',
  '🛡': 'Shield/3D/shield_3d.png', // Without variant selector
  
  // Reactions (with skin tone variants - use Default subfolder)
  '💪': 'Flexed biceps/Default/3D/flexed_biceps_3d_default.png',
  '👏': 'Clapping hands/Default/3D/clapping_hands_3d_default.png',
  '🎉': 'Party popper/3D/party_popper_3d.png',
  '❤️': 'Red heart/3D/red_heart_3d.png',
  '❤': 'Red heart/3D/red_heart_3d.png', // Without variant selector
  
  // Celebrations & UI
  '🏆': 'Trophy/3D/trophy_3d.png',
  '✨': 'Sparkles/3D/sparkles_3d.png',
  '🪄': 'Magic wand/3D/magic_wand_3d.png',
  '⭐': 'Star/3D/star_3d.png',
  '🌟': 'Glowing star/3D/glowing_star_3d.png',
  '🎯': 'Bullseye/3D/bullseye_3d.png',
  '🚀': 'Rocket/3D/rocket_3d.png',
  '💫': 'Dizzy/3D/dizzy_3d.png',
  '🎊': 'Confetti ball/3D/confetti_ball_3d.png',
  '🥇': '1st place medal/3D/1st_place_medal_3d.png',
  '🥈': '2nd place medal/3D/2nd_place_medal_3d.png',
  '🥉': '3rd place medal/3D/3rd_place_medal_3d.png',
  '📸': 'Camera with flash/3D/camera_with_flash_3d.png',
  '📷': 'Camera/3D/camera_3d.png',
  '✅': 'Check mark button/3D/check_mark_button_3d.png',
  '❌': 'Cross mark/3D/cross_mark_3d.png',
  '⚡': 'High voltage/3D/high_voltage_3d.png',
  '💰': 'Money bag/3D/money_bag_3d.png',
  '🎮': 'Video game/3D/video_game_3d.png',
  '📅': 'Calendar/3D/calendar_3d.png',
  '🎁': 'Wrapped gift/3D/wrapped_gift_3d.png',
  '👋': 'Waving hand/Default/3D/waving_hand_3d_default.png',
  '😊': 'Smiling face with smiling eyes/3D/smiling_face_with_smiling_eyes_3d.png',
  '🙌': 'Raising hands/Default/3D/raising_hands_3d_default.png',
  '💯': 'Hundred points/3D/hundred_points_3d.png',
  '🔒': 'Locked/3D/locked_3d.png',
  '🔓': 'Unlocked/3D/unlocked_3d.png',
  '📝': 'Memo/3D/memo_3d.png',
  '📖': 'Open book/3D/open_book_3d.png',
  '💡': 'Light bulb/3D/light_bulb_3d.png',
  '🎨': 'Artist palette/3D/artist_palette_3d.png',
  '🌙': 'Crescent moon/3D/crescent_moon_3d.png',
  '🌛': 'First quarter moon face/3D/first_quarter_moon_face_3d.png',
  '☀️': 'Sun/3D/sun_3d.png',
  '☀': 'Sun/3D/sun_3d.png',
  '🌞': 'Sun with face/3D/sun_with_face_3d.png',
  
  // Additional UI emojis
  '🤖': 'Robot/3D/robot_3d.png',
  '🏪': 'Convenience store/3D/convenience_store_3d.png',
  '🏝️': 'Desert island/3D/desert_island_3d.png',
  '🏝': 'Desert island/3D/desert_island_3d.png',
  '☕': 'Hot beverage/3D/hot_beverage_3d.png',
  
  // Animals
  '🦋': 'Butterfly/3D/butterfly_3d.png',
  '🦉': 'Owl/3D/owl_3d.png',
  '🐦': 'Bird/3D/bird_3d.png',
  '🕊️': 'Dove/3D/dove_3d.png',
  '🕊': 'Dove/3D/dove_3d.png',
  
  // Activities & Objects
  '⚔️': 'Crossed swords/3D/crossed_swords_3d.png',
  '⚔': 'Crossed swords/3D/crossed_swords_3d.png',
  '👣': 'Footprints/3D/footprints_3d.png',
  
  // Profile & Achievement
  '🏅': 'Sports medal/3D/sports_medal_3d.png',
  '🎖️': 'Military medal/3D/military_medal_3d.png',
  '🎖': 'Military medal/3D/military_medal_3d.png',
  '👑': 'Crown/3D/crown_3d.png',
  '🤝': 'Handshake/3D/handshake_3d.png',
  '📊': 'Bar chart/3D/bar_chart_3d.png',
  '📈': 'Chart increasing/3D/chart_increasing_3d.png',
  '📣': 'Megaphone/3D/megaphone_3d.png',
  '📢': 'Loudspeaker/3D/loudspeaker_3d.png',
  '🚫': 'Prohibited/3D/prohibited_3d.png',
  '😠': 'Angry face/3D/angry_face_3d.png',
  '🙋': 'Person raising hand/3D/person_raising_hand_3d.png',
  '👆': 'Backhand index pointing up/Default/3D/backhand_index_pointing_up_3d_default.png',
  '➡️': 'Right arrow/3D/right_arrow_3d.png',
  '⬅️': 'Left arrow/3D/left_arrow_3d.png',
  '↩️': 'Right arrow curving left/3D/right_arrow_curving_left_3d.png',
  '↩': 'Right arrow curving left/3D/right_arrow_curving_left_3d.png',
  '🔗': 'Link/3D/link_3d.png',
  '⏰': 'Alarm clock/3D/alarm_clock_3d.png',
  
  // Actions & UI
  '🔄': 'Counterclockwise arrows button/3D/counterclockwise_arrows_button_3d.png',
  '✏️': 'Pencil/3D/pencil_3d.png',
  '✏': 'Pencil/3D/pencil_3d.png',
  '🚩': 'Triangular flag/3D/triangular_flag_3d.png',
  '🏁': 'Chequered flag/3D/chequered_flag_3d.png',
  '⬆️': 'Up arrow/3D/up_arrow_3d.png',
  '⬇️': 'Down arrow/3D/down_arrow_3d.png',
  '➕': 'Plus/3D/plus_3d.png',
  '➖': 'Minus/3D/minus_3d.png',
  '♾️': 'Infinity/3D/infinity_3d.png',
  '♾': 'Infinity/3D/infinity_3d.png',
  '🗑️': 'Wastebasket/3D/wastebasket_3d.png',
  '🗑': 'Wastebasket/3D/wastebasket_3d.png',
  '📁': 'File folder/3D/file_folder_3d.png',
  '📤': 'Outbox tray/3D/outbox_tray_3d.png',
  '🖼️': 'Framed picture/3D/framed_picture_3d.png',
  '🖼': 'Framed picture/3D/framed_picture_3d.png',
  '💾': 'Floppy disk/3D/floppy_disk_3d.png',
  '🚪': 'Door/3D/door_3d.png',
  '⚠️': 'Warning/3D/warning_3d.png',
  '⚠': 'Warning/3D/warning_3d.png',
  
  '🛠️': 'Hammer and wrench/3D/hammer_and_wrench_3d.png',
  '🛠': 'Hammer and wrench/3D/hammer_and_wrench_3d.png', // Without variant selector
  
  // Settings icons
  '🔤': 'Input latin letters/3D/input_latin_letters_3d.png',
  '🌍': 'Globe showing Europe-Africa/3D/globe_showing_europe-africa_3d.png',
  '📦': 'Package/3D/package_3d.png',
  '📋': 'Clipboard/3D/clipboard_3d.png',
  '📂': 'Open file folder/3D/open_file_folder_3d.png',
  '➡': 'Right arrow/3D/right_arrow_3d.png',
  '✓': 'Check mark/3D/check_mark_3d.png',
  '✔️': 'Check mark/3D/check_mark_3d.png',
  '✔': 'Check mark/3D/check_mark_3d.png',
  '📰': 'Newspaper/3D/newspaper_3d.png',
  '🔍': 'Magnifying glass tilted left/3D/magnifying_glass_tilted_left_3d.png',
  '🗄️': 'File cabinet/3D/file_cabinet_3d.png',
  '🗄': 'File cabinet/3D/file_cabinet_3d.png',
  '🌐': 'Globe with meridians/3D/globe_with_meridians_3d.png',
  '📄': 'Page facing up/3D/page_facing_up_3d.png',
  '🗃️': 'Card file box/3D/card_file_box_3d.png',
  '🗃': 'Card file box/3D/card_file_box_3d.png',
  '💻': 'Laptop/3D/laptop_3d.png',
  '🅰️': 'A button (blood type)/3D/a_button_(blood_type)_3d.png',
  '🅰': 'A button (blood type)/3D/a_button_(blood_type)_3d.png',
  '📧': 'E-mail/3D/e-mail_3d.png',
  '🛍️': 'Shopping bags/3D/shopping_bags_3d.png',
  '🛍': 'Shopping bags/3D/shopping_bags_3d.png',
  
  // Habit presets & activity icons
  '🏃': 'Person running/Default/3D/person_running_3d_default.png',
  '🚶': 'Person walking/Default/3D/person_walking_3d_default.png',
  '📚': 'Books/3D/books_3d.png',
  '🎸': 'Guitar/3D/guitar_3d.png',
  '🧘': 'Person in lotus position/Default/3D/person_in_lotus_position_3d_default.png',
  '✍️': 'Writing hand/Default/3D/writing_hand_3d_default.png',
  '✍': 'Writing hand/Default/3D/writing_hand_3d_default.png',
  '🌱': 'Seedling/3D/seedling_3d.png',
  '🌅': 'Sunrise/3D/sunrise_3d.png',
  '📵': 'No mobile phones/3D/no_mobile_phones_3d.png',
  '🙏': 'Folded hands/Default/3D/folded_hands_3d_default.png',
  '🍅': 'Tomato/3D/tomato_3d.png',
  '🥗': 'Green salad/3D/green_salad_3d.png',
  '🥶': 'Cold face/3D/cold_face_3d.png',
  '🍬': 'Candy/3D/candy_3d.png',
  
  // Comments & communication
  '💬': 'Speech balloon/3D/speech_balloon_3d.png',
  
  // Security & identity
  '🔑': 'Key/3D/key_3d.png',
  '🔐': 'Locked with key/3D/locked_with_key_3d.png',
  '🆔': 'ID button/3D/id_button_3d.png',
  
  // Hearts
  '💖': 'Sparkling heart/3D/sparkling_heart_3d.png',
  '💛': 'Yellow heart/3D/yellow_heart_3d.png',
  '💜': 'Purple heart/3D/purple_heart_3d.png',
  
  // Partnership & Accountability
  '👀': 'Eyes/3D/eyes_3d.png',
  '💔': 'Broken heart/3D/broken_heart_3d.png',
  '🤷': 'Person shrugging/Default/3D/person_shrugging_3d_default.png',
  '📨': 'Incoming envelope/3D/incoming_envelope_3d.png',
  '⏳': 'Hourglass not done/3D/hourglass_not_done_3d.png',
  '📍': 'Round pushpin/3D/round_pushpin_3d.png',

  // Snooze & Pause
  '😴': 'Sleeping face/3D/sleeping_face_3d.png',
  '⏸️': 'Pause button/3D/pause_button_3d.png',
  '⏸': 'Pause button/3D/pause_button_3d.png',
  '🗓️': 'Spiral calendar/3D/spiral_calendar_3d.png',
  '🗓': 'Spiral calendar/3D/spiral_calendar_3d.png',
  '✈️': 'Airplane/3D/airplane_3d.png',
  '✈': 'Airplane/3D/airplane_3d.png',
  '🏥': 'Hospital/3D/hospital_3d.png',
  
  // Notifications & Communication
  '📬': 'Open mailbox with raised flag/3D/open_mailbox_with_raised_flag_3d.png',
  '💌': 'Love letter/3D/love_letter_3d.png',
  '🌆': 'Cityscape at dusk/3D/cityscape_at_dusk_3d.png',
  '🚨': 'Police car light/3D/police_car_light_3d.png',
  
  // Misc
  '🧊': 'Ice/3D/ice_3d.png',
  '🔔': 'Bell/3D/bell_3d.png',
  '🔕': 'Bell with slash/3D/bell_with_slash_3d.png',
  
  // Mobile & Installation
  '📱': 'Mobile phone/3D/mobile_phone_3d.png',
  '📲': 'Mobile phone with arrow/3D/mobile_phone_with_arrow_3d.png',
  '📜': 'Scroll/3D/scroll_3d.png',
  '📥': 'Inbox tray/3D/inbox_tray_3d.png',
  '🖱️': 'Computer mouse/3D/computer_mouse_3d.png',
  '🖱': 'Computer mouse/3D/computer_mouse_3d.png',
  '📴': 'Mobile phone off/3D/mobile_phone_off_3d.png',
  
  // Effects & atmosphere
  '💨': 'Dashing away/3D/dashing_away_3d.png',
  '🌫️': 'Fog/3D/fog_3d.png',
  '🌫': 'Fog/3D/fog_3d.png',
  
  // Sports - People (skin tone variants use Default subfolder)
  '🏋️': 'Person lifting weights/Default/3D/person_lifting_weights_3d_default.png',
  '🏋': 'Person lifting weights/Default/3D/person_lifting_weights_3d_default.png',
  '🚴': 'Person biking/Default/3D/person_biking_3d_default.png',
  '🏊': 'Person swimming/Default/3D/person_swimming_3d_default.png',
  '🤸': 'Person cartwheeling/Default/3D/person_cartwheeling_3d_default.png',
  '🧗': 'Person climbing/Default/3D/person_climbing_3d_default.png',
  '🤾': 'Person playing handball/Default/3D/person_playing_handball_3d_default.png',
  '🏌️': 'Person golfing/Default/3D/person_golfing_3d_default.png',
  '🏌': 'Person golfing/Default/3D/person_golfing_3d_default.png',
  '🏇': 'Horse racing/Default/3D/horse_racing_3d_default.png',
  
  // Sports - Ball & equipment
  '⚽': 'Soccer ball/3D/soccer_ball_3d.png',
  '🏀': 'Basketball/3D/basketball_3d.png',
  '🎾': 'Tennis/3D/tennis_3d.png',
  '🥊': 'Boxing glove/3D/boxing_glove_3d.png',
  '🥋': 'Martial arts uniform/3D/martial_arts_uniform_3d.png',
  '🏈': 'American football/3D/american_football_3d.png',
  '⚾': 'Baseball/3D/baseball_3d.png',
  '🥎': 'Softball/3D/softball_3d.png',
  '🏐': 'Volleyball/3D/volleyball_3d.png',
  '🏉': 'Rugby football/3D/rugby_football_3d.png',
  '🥏': 'Flying disc/3D/flying_disc_3d.png',
  '🎳': 'Bowling/3D/bowling_3d.png',
  '🏏': 'Cricket game/3D/cricket_game_3d.png',
  '🏑': 'Field hockey/3D/field_hockey_3d.png',
  '🏒': 'Ice hockey/3D/ice_hockey_3d.png',
  '🥍': 'Lacrosse/3D/lacrosse_3d.png',
  '🏓': 'Ping pong/3D/ping_pong_3d.png',
  '🏸': 'Badminton/3D/badminton_3d.png',
  
  // Sports - Winter & outdoor
  '🏂': 'Snowboarder/Default/3D/snowboarder_3d_default.png',
  '⛷️': 'Skier/3D/skier_3d.png',
  '⛷': 'Skier/3D/skier_3d.png',
  '🎿': 'Skis/3D/skis_3d.png',
  '🛹': 'Skateboard/3D/skateboard_3d.png',
  '⛳': 'Flag in hole/3D/flag_in_hole_3d.png',
  '⛸️': 'Ice skate/3D/ice_skate_3d.png',
  '⛸': 'Ice skate/3D/ice_skate_3d.png',
  '🛷': 'Sled/3D/sled_3d.png',
  '🥌': 'Curling stone/3D/curling_stone_3d.png',
}

// Map emoji characters to their Animated Fluent Emoji paths
// Using the official Microsoft repository structure: {Folder}/[Default/]animated/{filename}.png
// Emojis with skin tones use the "Default" subfolder
type AnimatedEmojiConfig = { folder: string; file: string; hasDefault?: boolean }
export const ANIMATED_EMOJI_MAP: Record<string, AnimatedEmojiConfig> = {
  // === REACTIONS & CELEBRATIONS ===
  '🔥': { folder: 'Fire', file: 'fire_animated' },
  '🎉': { folder: 'Party popper', file: 'party_popper_animated' },
  // '✨' Sparkles - NO ANIMATED VERSION (use static 3D)
  '💪': { folder: 'Flexed biceps', file: 'flexed_biceps_animated_default', hasDefault: true },
  '👏': { folder: 'Clapping hands', file: 'clapping_hands_animated_default', hasDefault: true },
  '❤️': { folder: 'Red heart', file: 'red_heart_animated' },
  '❤': { folder: 'Red heart', file: 'red_heart_animated' },
  '🚀': { folder: 'Rocket', file: 'rocket_animated' },
  '⭐': { folder: 'Star', file: 'star_animated' },
  '🌟': { folder: 'Glowing star', file: 'glowing_star_animated' },
  '💫': { folder: 'Dizzy', file: 'dizzy_animated' },
  '🎊': { folder: 'Confetti ball', file: 'confetti_ball_animated' },
  '🎁': { folder: 'Wrapped gift', file: 'wrapped_gift_animated' },
  '👋': { folder: 'Waving hand', file: 'waving_hand_animated_default', hasDefault: true },
  '🙌': { folder: 'Raising hands', file: 'raising_hands_animated_default', hasDefault: true },
  '💯': { folder: 'Hundred points', file: 'hundred_points_animated' },
  '👑': { folder: 'Crown', file: 'crown_animated' },
  '⚡': { folder: 'High voltage', file: 'high_voltage_animated' },
  '💡': { folder: 'Light bulb', file: 'light_bulb_animated' },
  // '🪄' Magic wand - NO ANIMATED VERSION (use static 3D)
  '😊': { folder: 'Smiling face with smiling eyes', file: 'smiling_face_with_smiling_eyes_animated' },
  '👆': { folder: 'Backhand index pointing up', file: 'backhand_index_pointing_up_animated_default', hasDefault: true },
  // '🔔' Bell - NO ANIMATED VERSION (use static 3D)
  '💰': { folder: 'Money bag', file: 'money_bag_animated' },
  
  // === MEDALS & ACHIEVEMENTS ===
  // NOTE: These medals/trophy/gem DO NOT have animated versions in Microsoft repo
  // '🥇' 1st place medal - NO ANIMATED VERSION (use static 3D)
  // '🥈' 2nd place medal - NO ANIMATED VERSION (use static 3D)
  // '🥉' 3rd place medal - NO ANIMATED VERSION (use static 3D)
  // '🏆' Trophy - NO ANIMATED VERSION (use static 3D)
  // '💎' Gem stone - NO ANIMATED VERSION (use static 3D)
  // '🏅' Sports medal - NO ANIMATED VERSION (use static 3D)
  
  // === NAVIGATION & UI ===
  '🏠': { folder: 'House', file: 'house_animated' },
  '👥': { folder: 'Busts in silhouette', file: 'busts_in_silhouette_animated' },
  '👤': { folder: 'Bust in silhouette', file: 'bust_in_silhouette_animated' },
  // '🛒' Shopping cart - NO ANIMATED VERSION (use static 3D)
  // '⚙️' Gear - NO ANIMATED VERSION (use static 3D)
  // '⚙' Gear - NO ANIMATED VERSION (use static 3D)
  // '🛡️' Shield - NO ANIMATED VERSION (use static 3D)
  // '🛡' Shield - NO ANIMATED VERSION (use static 3D)
  '🧭': { folder: 'Compass', file: 'compass_animated' },
  
  // === THEME & TIME ===
  '🌞': { folder: 'Sun with face', file: 'sun_with_face_animated' },
  '🌛': { folder: 'First quarter moon face', file: 'first_quarter_moon_face_animated' },
  '🌙': { folder: 'Crescent moon', file: 'crescent_moon_animated' },
  '☀️': { folder: 'Sun', file: 'sun_animated' },
  '☀': { folder: 'Sun', file: 'sun_animated' },
  '⏰': { folder: 'Alarm clock', file: 'alarm_clock_animated' },
  
  // === PEOPLE & GESTURES (with skin tone default) ===
  '🏃': { folder: 'Person running', file: 'person_running_animated_default', hasDefault: true },
  '🧘': { folder: 'Person in lotus position', file: 'person_in_lotus_position_animated_default', hasDefault: true },
  '✍️': { folder: 'Writing hand', file: 'writing_hand_animated_default', hasDefault: true },
  '✍': { folder: 'Writing hand', file: 'writing_hand_animated_default', hasDefault: true },
  '🙏': { folder: 'Folded hands', file: 'folded_hands_animated_default', hasDefault: true },
  '🙋': { folder: 'Person raising hand', file: 'person_raising_hand_animated_default', hasDefault: true },
  '👍': { folder: 'Thumbs up', file: 'thumbs_up_animated_default', hasDefault: true },
  '👎': { folder: 'Thumbs down', file: 'thumbs_down_animated_default', hasDefault: true },
  '✋': { folder: 'Raised hand', file: 'raised_hand_animated_default', hasDefault: true },
  '🤝': { folder: 'Handshake', file: 'handshake_animated_default', hasDefault: true },
  '🤞': { folder: 'Crossed fingers', file: 'crossed_fingers_animated_default', hasDefault: true },
  '🤙': { folder: 'Call me hand', file: 'call_me_hand_animated_default', hasDefault: true },
  '🤘': { folder: 'Sign of the horns', file: 'sign_of_the_horns_animated_default', hasDefault: true },
  '✌️': { folder: 'Victory hand', file: 'victory_hand_animated_default', hasDefault: true },
  '✌': { folder: 'Victory hand', file: 'victory_hand_animated_default', hasDefault: true },
  '🖐️': { folder: 'Hand with fingers splayed', file: 'hand_with_fingers_splayed_animated_default', hasDefault: true },
  '🖐': { folder: 'Hand with fingers splayed', file: 'hand_with_fingers_splayed_animated_default', hasDefault: true },
  '🤚': { folder: 'Raised back of hand', file: 'raised_back_of_hand_animated_default', hasDefault: true },
  '👌': { folder: 'OK hand', file: 'ok_hand_animated_default', hasDefault: true },
  '🤏': { folder: 'Pinching hand', file: 'pinching_hand_animated_default', hasDefault: true },
  '👊': { folder: 'Oncoming fist', file: 'oncoming_fist_animated_default', hasDefault: true },
  '🤛': { folder: 'Left-facing fist', file: 'left-facing_fist_animated_default', hasDefault: true },
  '🤜': { folder: 'Right-facing fist', file: 'right-facing_fist_animated_default', hasDefault: true },
  '🫵': { folder: 'Index pointing at the viewer', file: 'index_pointing_at_the_viewer_animated_default', hasDefault: true },
  '👇': { folder: 'Backhand index pointing down', file: 'backhand_index_pointing_down_animated_default', hasDefault: true },
  '👈': { folder: 'Backhand index pointing left', file: 'backhand_index_pointing_left_animated_default', hasDefault: true },
  '👉': { folder: 'Backhand index pointing right', file: 'backhand_index_pointing_right_animated_default', hasDefault: true },
  '☝️': { folder: 'Index pointing up', file: 'index_pointing_up_animated_default', hasDefault: true },
  '☝': { folder: 'Index pointing up', file: 'index_pointing_up_animated_default', hasDefault: true },
  '🫶': { folder: 'Heart hands', file: 'heart_hands_animated_default', hasDefault: true },
  '🫰': { folder: 'Hand with index finger and thumb crossed', file: 'hand_with_index_finger_and_thumb_crossed_animated_default', hasDefault: true },
  '🫳': { folder: 'Palm down hand', file: 'palm_down_hand_animated_default', hasDefault: true },
  '🫴': { folder: 'Palm up hand', file: 'palm_up_hand_animated_default', hasDefault: true },
  '🙂': { folder: 'Slightly smiling face', file: 'slightly_smiling_face_animated' },
  '😀': { folder: 'Grinning face', file: 'grinning_face_animated' },
  '😁': { folder: 'Beaming face with smiling eyes', file: 'beaming_face_with_smiling_eyes_animated' },
  '😂': { folder: 'Face with tears of joy', file: 'face_with_tears_of_joy_animated' },
  '🤣': { folder: 'Rolling on the floor laughing', file: 'rolling_on_the_floor_laughing_animated' },
  '😃': { folder: 'Grinning face with big eyes', file: 'grinning_face_with_big_eyes_animated' },
  '😄': { folder: 'Grinning face with smiling eyes', file: 'grinning_face_with_smiling_eyes_animated' },
  '😅': { folder: 'Grinning face with sweat', file: 'grinning_face_with_sweat_animated' },
  '😆': { folder: 'Grinning squinting face', file: 'grinning_squinting_face_animated' },
  '😉': { folder: 'Winking face', file: 'winking_face_animated' },
  '😍': { folder: 'Smiling face with heart-eyes', file: 'smiling_face_with_heart-eyes_animated' },
  '🥰': { folder: 'Smiling face with hearts', file: 'smiling_face_with_hearts_animated' },
  '😘': { folder: 'Face blowing a kiss', file: 'face_blowing_a_kiss_animated' },
  '😎': { folder: 'Smiling face with sunglasses', file: 'smiling_face_with_sunglasses_animated' },
  '🤩': { folder: 'Star-struck', file: 'star-struck_animated' },
  '🥳': { folder: 'Partying face', file: 'partying_face_animated' },
  '😇': { folder: 'Smiling face with halo', file: 'smiling_face_with_halo_animated' },
  '🤗': { folder: 'Smiling face with open hands', file: 'smiling_face_with_open_hands_animated' },
  '🤔': { folder: 'Thinking face', file: 'thinking_face_animated' },
  '🤫': { folder: 'Shushing face', file: 'shushing_face_animated' },
  '🤭': { folder: 'Face with hand over mouth', file: 'face_with_hand_over_mouth_animated' },
  '😋': { folder: 'Face savoring food', file: 'face_savoring_food_animated' },
  '😜': { folder: 'Winking face with tongue', file: 'winking_face_with_tongue_animated' },
  '😝': { folder: 'Squinting face with tongue', file: 'squinting_face_with_tongue_animated' },
  '🤪': { folder: 'Zany face', file: 'zany_face_animated' },
  '😏': { folder: 'Smirking face', file: 'smirking_face_animated' },
  '😌': { folder: 'Relieved face', file: 'relieved_face_animated' },
  '😴': { folder: 'Sleeping face', file: 'sleeping_face_animated' },
  '🤤': { folder: 'Drooling face', file: 'drooling_face_animated' },
  '😷': { folder: 'Face with medical mask', file: 'face_with_medical_mask_animated' },
  '🤒': { folder: 'Face with thermometer', file: 'face_with_thermometer_animated' },
  '🤕': { folder: 'Face with head-bandage', file: 'face_with_head-bandage_animated' },
  '🤮': { folder: 'Face vomiting', file: 'face_vomiting_animated' },
  '🥴': { folder: 'Woozy face', file: 'woozy_face_animated' },
  '😵': { folder: 'Face with crossed-out eyes', file: 'face_with_crossed-out_eyes_animated' },
  '🤯': { folder: 'Exploding head', file: 'exploding_head_animated' },
  '🥺': { folder: 'Pleading face', file: 'pleading_face_animated' },
  '😢': { folder: 'Crying face', file: 'crying_face_animated' },
  '😭': { folder: 'Loudly crying face', file: 'loudly_crying_face_animated' },
  '😤': { folder: 'Face with steam from nose', file: 'face_with_steam_from_nose_animated' },
  '😠': { folder: 'Angry face', file: 'angry_face_animated' },
  '😡': { folder: 'Pouting face', file: 'pouting_face_animated' },
  '🤬': { folder: 'Face with symbols on mouth', file: 'face_with_symbols_on_mouth_animated' },
  '😈': { folder: 'Smiling face with horns', file: 'smiling_face_with_horns_animated' },
  '👿': { folder: 'Angry face with horns', file: 'angry_face_with_horns_animated' },
  '💀': { folder: 'Skull', file: 'skull_animated' },
  '☠️': { folder: 'Skull and crossbones', file: 'skull_and_crossbones_animated' },
  '☠': { folder: 'Skull and crossbones', file: 'skull_and_crossbones_animated' },
  '👻': { folder: 'Ghost', file: 'ghost_animated' },
  '👽': { folder: 'Alien', file: 'alien_animated' },
  '🤖': { folder: 'Robot', file: 'robot_animated' },
  '💩': { folder: 'Pile of poo', file: 'pile_of_poo_animated' },
  '🙈': { folder: 'See-no-evil monkey', file: 'see-no-evil_monkey_animated' },
  '🙉': { folder: 'Hear-no-evil monkey', file: 'hear-no-evil_monkey_animated' },
  '🙊': { folder: 'Speak-no-evil monkey', file: 'speak-no-evil_monkey_animated' },
  
  // === FOOD & DRINK ===
  // '🥗' Green salad - NO ANIMATED VERSION (use static 3D)
  // '🍬' Candy - NO ANIMATED VERSION (use static 3D)
  '🍕': { folder: 'Pizza', file: 'pizza_animated' },
  '🍔': { folder: 'Hamburger', file: 'hamburger_animated' },
  '🍟': { folder: 'French fries', file: 'french_fries_animated' },
  '🌭': { folder: 'Hot dog', file: 'hot_dog_animated' },
  '🍿': { folder: 'Popcorn', file: 'popcorn_animated' },
  '🧁': { folder: 'Cupcake', file: 'cupcake_animated' },
  '🍰': { folder: 'Shortcake', file: 'shortcake_animated' },
  '🎂': { folder: 'Birthday cake', file: 'birthday_cake_animated' },
  '🍩': { folder: 'Doughnut', file: 'doughnut_animated' },
  '🍪': { folder: 'Cookie', file: 'cookie_animated' },
  '🍫': { folder: 'Chocolate bar', file: 'chocolate_bar_animated' },
  '☕': { folder: 'Hot beverage', file: 'hot_beverage_animated' },
  '🍺': { folder: 'Beer mug', file: 'beer_mug_animated' },
  '🍻': { folder: 'Clinking beer mugs', file: 'clinking_beer_mugs_animated' },
  '🥂': { folder: 'Clinking glasses', file: 'clinking_glasses_animated' },
  '🍾': { folder: 'Bottle with popping cork', file: 'bottle_with_popping_cork_animated' },
  '🍷': { folder: 'Wine glass', file: 'wine_glass_animated' },
  '🥃': { folder: 'Tumbler glass', file: 'tumbler_glass_animated' },
  '🧃': { folder: 'Beverage box', file: 'beverage_box_animated' },
  '🧊': { folder: 'Ice', file: 'ice_animated' },
  
  // === ANIMALS ===
  '🐶': { folder: 'Dog face', file: 'dog_face_animated' },
  '🐱': { folder: 'Cat face', file: 'cat_face_animated' },
  '🐭': { folder: 'Mouse face', file: 'mouse_face_animated' },
  '🐹': { folder: 'Hamster', file: 'hamster_animated' },
  '🐰': { folder: 'Rabbit face', file: 'rabbit_face_animated' },
  '🦊': { folder: 'Fox', file: 'fox_animated' },
  '🐻': { folder: 'Bear', file: 'bear_animated' },
  '🐼': { folder: 'Panda', file: 'panda_animated' },
  '🐨': { folder: 'Koala', file: 'koala_animated' },
  '🐯': { folder: 'Tiger face', file: 'tiger_face_animated' },
  '🦁': { folder: 'Lion', file: 'lion_animated' },
  '🐮': { folder: 'Cow face', file: 'cow_face_animated' },
  '🐷': { folder: 'Pig face', file: 'pig_face_animated' },
  '🐸': { folder: 'Frog', file: 'frog_animated' },
  '🐵': { folder: 'Monkey face', file: 'monkey_face_animated' },
  '🙃': { folder: 'Upside-down face', file: 'upside-down_face_animated' },
  '🐔': { folder: 'Chicken', file: 'chicken_animated' },
  '🐧': { folder: 'Penguin', file: 'penguin_animated' },
  '🐦': { folder: 'Bird', file: 'bird_animated' },
  '🦅': { folder: 'Eagle', file: 'eagle_animated' },
  '🦆': { folder: 'Duck', file: 'duck_animated' },
  '🦉': { folder: 'Owl', file: 'owl_animated' },
  '🦇': { folder: 'Bat', file: 'bat_animated' },
  '🐺': { folder: 'Wolf', file: 'wolf_animated' },
  '🐗': { folder: 'Boar', file: 'boar_animated' },
  '🐴': { folder: 'Horse face', file: 'horse_face_animated' },
  '🦄': { folder: 'Unicorn', file: 'unicorn_animated' },
  '🐝': { folder: 'Honeybee', file: 'honeybee_animated' },
  '🦋': { folder: 'Butterfly', file: 'butterfly_animated' },
  '🐛': { folder: 'Bug', file: 'bug_animated' },
  '🐌': { folder: 'Snail', file: 'snail_animated' },
  '🐞': { folder: 'Lady beetle', file: 'lady_beetle_animated' },
  '🐜': { folder: 'Ant', file: 'ant_animated' },
  '🦟': { folder: 'Mosquito', file: 'mosquito_animated' },
  '🐢': { folder: 'Turtle', file: 'turtle_animated' },
  '🐍': { folder: 'Snake', file: 'snake_animated' },
  '🦎': { folder: 'Lizard', file: 'lizard_animated' },
  '🦈': { folder: 'Shark', file: 'shark_animated' },
  '🐙': { folder: 'Octopus', file: 'octopus_animated' },
  '🐠': { folder: 'Tropical fish', file: 'tropical_fish_animated' },
  '🐟': { folder: 'Fish', file: 'fish_animated' },
  '🐬': { folder: 'Dolphin', file: 'dolphin_animated' },
  '🐳': { folder: 'Spouting whale', file: 'spouting_whale_animated' },
  '🐋': { folder: 'Whale', file: 'whale_animated' },
  '🐊': { folder: 'Crocodile', file: 'crocodile_animated' },
  '🐘': { folder: 'Elephant', file: 'elephant_animated' },
  '🦒': { folder: 'Giraffe', file: 'giraffe_animated' },
  '🦏': { folder: 'Rhinoceros', file: 'rhinoceros_animated' },
  '🦛': { folder: 'Hippopotamus', file: 'hippopotamus_animated' },
  '🐪': { folder: 'Camel', file: 'camel_animated' },
  '🐫': { folder: 'Two-hump camel', file: 'two-hump_camel_animated' },
  '🦘': { folder: 'Kangaroo', file: 'kangaroo_animated' },
  '🦬': { folder: 'Bison', file: 'bison_animated' },
  '🐃': { folder: 'Water buffalo', file: 'water_buffalo_animated' },
  '🐂': { folder: 'Ox', file: 'ox_animated' },
  '🐄': { folder: 'Cow', file: 'cow_animated' },
  '🐎': { folder: 'Horse', file: 'horse_animated' },
  '🐖': { folder: 'Pig', file: 'pig_animated' },
  '🐏': { folder: 'Ram', file: 'ram_animated' },
  '🐑': { folder: 'Ewe', file: 'ewe_animated' },
  '🐐': { folder: 'Goat', file: 'goat_animated' },
  '🦌': { folder: 'Deer', file: 'deer_animated' },
  '🐕': { folder: 'Dog', file: 'dog_animated' },
  '🐩': { folder: 'Poodle', file: 'poodle_animated' },
  '🐈': { folder: 'Cat', file: 'cat_animated' },
  '🐓': { folder: 'Rooster', file: 'rooster_animated' },
  '🦃': { folder: 'Turkey', file: 'turkey_animated' },
  '🦚': { folder: 'Peacock', file: 'peacock_animated' },
  '🦜': { folder: 'Parrot', file: 'parrot_animated' },
  '🦢': { folder: 'Swan', file: 'swan_animated' },
  '🦩': { folder: 'Flamingo', file: 'flamingo_animated' },
  '🐇': { folder: 'Rabbit', file: 'rabbit_animated' },
  '🦝': { folder: 'Raccoon', file: 'raccoon_animated' },
  '🦡': { folder: 'Badger', file: 'badger_animated' },
  '🦫': { folder: 'Beaver', file: 'beaver_animated' },
  '🦦': { folder: 'Otter', file: 'otter_animated' },
  '🦥': { folder: 'Sloth', file: 'sloth_animated' },
  '🐁': { folder: 'Mouse', file: 'mouse_animated' },
  '🐀': { folder: 'Rat', file: 'rat_animated' },
  '🦔': { folder: 'Hedgehog', file: 'hedgehog_animated' },
  '🦨': { folder: 'Skunk', file: 'skunk_animated' },
  '🦙': { folder: 'Llama', file: 'llama_animated' },
  '🐲': { folder: 'Dragon face', file: 'dragon_face_animated' },
  '🐉': { folder: 'Dragon', file: 'dragon_animated' },
  
  // === NATURE & WEATHER ===
  '🥶': { folder: 'Cold face', file: 'cold_face_animated' },
  '🌸': { folder: 'Cherry blossom', file: 'cherry_blossom_animated' },
  '💮': { folder: 'White flower', file: 'white_flower_animated' },
  '🌹': { folder: 'Rose', file: 'rose_animated' },
  '🌺': { folder: 'Hibiscus', file: 'hibiscus_animated' },
  '🌻': { folder: 'Sunflower', file: 'sunflower_animated' },
  '🌼': { folder: 'Blossom', file: 'blossom_animated' },
  '🌷': { folder: 'Tulip', file: 'tulip_animated' },
  '🌱': { folder: 'Seedling', file: 'seedling_animated' },
  '🪴': { folder: 'Potted plant', file: 'potted_plant_animated' },
  '🌲': { folder: 'Evergreen tree', file: 'evergreen_tree_animated' },
  '🌳': { folder: 'Deciduous tree', file: 'deciduous_tree_animated' },
  '🌴': { folder: 'Palm tree', file: 'palm_tree_animated' },
  '🌵': { folder: 'Cactus', file: 'cactus_animated' },
  '🌾': { folder: 'Sheaf of rice', file: 'sheaf_of_rice_animated' },
  '🌿': { folder: 'Herb', file: 'herb_animated' },
  '☘️': { folder: 'Shamrock', file: 'shamrock_animated' },
  '☘': { folder: 'Shamrock', file: 'shamrock_animated' },
  '🍀': { folder: 'Four leaf clover', file: 'four_leaf_clover_animated' },
  '🍁': { folder: 'Maple leaf', file: 'maple_leaf_animated' },
  '🍂': { folder: 'Fallen leaf', file: 'fallen_leaf_animated' },
  '🍃': { folder: 'Leaf fluttering in wind', file: 'leaf_fluttering_in_wind_animated' },
  '🪺': { folder: 'Nest with eggs', file: 'nest_with_eggs_animated' },
  '🌈': { folder: 'Rainbow', file: 'rainbow_animated' },
  '🌊': { folder: 'Water wave', file: 'water_wave_animated' },
  '💧': { folder: 'Droplet', file: 'droplet_animated' },
  '💦': { folder: 'Sweat droplets', file: 'sweat_droplets_animated' },
  '🌀': { folder: 'Cyclone', file: 'cyclone_animated' },
  '🌪️': { folder: 'Tornado', file: 'tornado_animated' },
  '🌪': { folder: 'Tornado', file: 'tornado_animated' },
  '🌤️': { folder: 'Sun behind small cloud', file: 'sun_behind_small_cloud_animated' },
  '🌤': { folder: 'Sun behind small cloud', file: 'sun_behind_small_cloud_animated' },
  '⛅': { folder: 'Sun behind cloud', file: 'sun_behind_cloud_animated' },
  '🌥️': { folder: 'Sun behind large cloud', file: 'sun_behind_large_cloud_animated' },
  '🌥': { folder: 'Sun behind large cloud', file: 'sun_behind_large_cloud_animated' },
  '☁️': { folder: 'Cloud', file: 'cloud_animated' },
  '☁': { folder: 'Cloud', file: 'cloud_animated' },
  '🌦️': { folder: 'Sun behind rain cloud', file: 'sun_behind_rain_cloud_animated' },
  '🌦': { folder: 'Sun behind rain cloud', file: 'sun_behind_rain_cloud_animated' },
  '🌧️': { folder: 'Cloud with rain', file: 'cloud_with_rain_animated' },
  '🌧': { folder: 'Cloud with rain', file: 'cloud_with_rain_animated' },
  '⛈️': { folder: 'Cloud with lightning and rain', file: 'cloud_with_lightning_and_rain_animated' },
  '⛈': { folder: 'Cloud with lightning and rain', file: 'cloud_with_lightning_and_rain_animated' },
  '🌩️': { folder: 'Cloud with lightning', file: 'cloud_with_lightning_animated' },
  '🌩': { folder: 'Cloud with lightning', file: 'cloud_with_lightning_animated' },
  '🌨️': { folder: 'Cloud with snow', file: 'cloud_with_snow_animated' },
  '🌨': { folder: 'Cloud with snow', file: 'cloud_with_snow_animated' },
  '❄️': { folder: 'Snowflake', file: 'snowflake_animated' },
  '❄': { folder: 'Snowflake', file: 'snowflake_animated' },
  '⛄': { folder: 'Snowman without snow', file: 'snowman_without_snow_animated' },
  '☃️': { folder: 'Snowman', file: 'snowman_animated' },
  '☃': { folder: 'Snowman', file: 'snowman_animated' },
  '🔫': { folder: 'Water pistol', file: 'water_pistol_animated' },
  '💨': { folder: 'Dashing away', file: 'dashing_away_animated' },
  '🌫️': { folder: 'Fog', file: 'fog_animated' },
  '🌫': { folder: 'Fog', file: 'fog_animated' },
  // '🌅' Sunrise - NO ANIMATED VERSION (use static 3D)
  '🌄': { folder: 'Sunrise over mountains', file: 'sunrise_over_mountains_animated' },
  '🌇': { folder: 'Sunset', file: 'sunset_animated' },
  '🌆': { folder: 'Cityscape at dusk', file: 'cityscape_at_dusk_animated' },
  '🌃': { folder: 'Night with stars', file: 'night_with_stars_animated' },
  '🌌': { folder: 'Milky way', file: 'milky_way_animated' },
  '🌉': { folder: 'Bridge at night', file: 'bridge_at_night_animated' },
  
  // === OBJECTS & TOOLS ===
  '📸': { folder: 'Camera with flash', file: 'camera_with_flash_animated' },
  '📷': { folder: 'Camera', file: 'camera_animated' },
  '📹': { folder: 'Video camera', file: 'video_camera_animated' },
  '📺': { folder: 'Television', file: 'television_animated' },
  '💻': { folder: 'Laptop', file: 'laptop_animated' },
  '🖥️': { folder: 'Desktop computer', file: 'desktop_computer_animated' },
  '🖥': { folder: 'Desktop computer', file: 'desktop_computer_animated' },
  '🖨️': { folder: 'Printer', file: 'printer_animated' },
  '🖨': { folder: 'Printer', file: 'printer_animated' },
  '⌨️': { folder: 'Keyboard', file: 'keyboard_animated' },
  '⌨': { folder: 'Keyboard', file: 'keyboard_animated' },
  '🖱️': { folder: 'Computer mouse', file: 'computer_mouse_animated' },
  '🖱': { folder: 'Computer mouse', file: 'computer_mouse_animated' },
  '📱': { folder: 'Mobile phone', file: 'mobile_phone_animated' },
  '📲': { folder: 'Mobile phone with arrow', file: 'mobile_phone_with_arrow_animated' },
  '☎️': { folder: 'Telephone', file: 'telephone_animated' },
  '☎': { folder: 'Telephone', file: 'telephone_animated' },
  '📞': { folder: 'Telephone receiver', file: 'telephone_receiver_animated' },
  '📟': { folder: 'Pager', file: 'pager_animated' },
  '📠': { folder: 'Fax machine', file: 'fax_machine_animated' },
  '🔋': { folder: 'Battery', file: 'battery_animated' },
  '🔌': { folder: 'Electric plug', file: 'electric_plug_animated' },
  '💾': { folder: 'Floppy disk', file: 'floppy_disk_animated' },
  '💿': { folder: 'Optical disk', file: 'optical_disk_animated' },
  '📀': { folder: 'DVD', file: 'dvd_animated' },
  '🎬': { folder: 'Clapper board', file: 'clapper_board_animated' },
  '🎤': { folder: 'Microphone', file: 'microphone_animated' },
  '🎧': { folder: 'Headphone', file: 'headphone_animated' },
  '📻': { folder: 'Radio', file: 'radio_animated' },
  '🎷': { folder: 'Saxophone', file: 'saxophone_animated' },
  '🎸': { folder: 'Guitar', file: 'guitar_animated' },
  '🎹': { folder: 'Musical keyboard', file: 'musical_keyboard_animated' },
  '🎺': { folder: 'Trumpet', file: 'trumpet_animated' },
  '🎻': { folder: 'Violin', file: 'violin_animated' },
  '🥁': { folder: 'Drum', file: 'drum_animated' },
  '🎮': { folder: 'Video game', file: 'video_game_animated' },
  '🎰': { folder: 'Slot machine', file: 'slot_machine_animated' },
  '🎲': { folder: 'Game die', file: 'game_die_animated' },
  '🧩': { folder: 'Puzzle piece', file: 'puzzle_piece_animated' },
  // '🎯' Bullseye - NO ANIMATED VERSION (use static 3D)
  '🎱': { folder: 'Pool 8 ball', file: 'pool_8_ball_animated' },
  '🔮': { folder: 'Crystal ball', file: 'crystal_ball_animated' },
  '🧿': { folder: 'Nazar amulet', file: 'nazar_amulet_animated' },
  '🏀': { folder: 'Basketball', file: 'basketball_animated' },
  '⚽': { folder: 'Soccer ball', file: 'soccer_ball_animated' },
  '🏈': { folder: 'American football', file: 'american_football_animated' },
  '⚾': { folder: 'Baseball', file: 'baseball_animated' },
  '🥎': { folder: 'Softball', file: 'softball_animated' },
  '🎾': { folder: 'Tennis', file: 'tennis_animated' },
  '🏐': { folder: 'Volleyball', file: 'volleyball_animated' },
  '🏉': { folder: 'Rugby football', file: 'rugby_football_animated' },
  '🥏': { folder: 'Flying disc', file: 'flying_disc_animated' },
  '🎳': { folder: 'Bowling', file: 'bowling_animated' },
  '🏏': { folder: 'Cricket game', file: 'cricket_game_animated' },
  '🏑': { folder: 'Field hockey', file: 'field_hockey_animated' },
  '🏒': { folder: 'Ice hockey', file: 'ice_hockey_animated' },
  '🥍': { folder: 'Lacrosse', file: 'lacrosse_animated' },
  '🏓': { folder: 'Ping pong', file: 'ping_pong_animated' },
  '🏸': { folder: 'Badminton', file: 'badminton_animated' },
  '🥊': { folder: 'Boxing glove', file: 'boxing_glove_animated' },
  '🥋': { folder: 'Martial arts uniform', file: 'martial_arts_uniform_animated' },
  '⛳': { folder: 'Flag in hole', file: 'flag_in_hole_animated' },
  '⛸️': { folder: 'Ice skate', file: 'ice_skate_animated' },
  '⛸': { folder: 'Ice skate', file: 'ice_skate_animated' },
  '🎿': { folder: 'Skis', file: 'skis_animated' },
  '⛷️': { folder: 'Skier', file: 'skier_animated' },
  '⛷': { folder: 'Skier', file: 'skier_animated' },
  '🏂': { folder: 'Snowboarder', file: 'snowboarder_animated' },
  '🏋️': { folder: 'Person lifting weights', file: 'person_lifting_weights_animated' },
  '🏋': { folder: 'Person lifting weights', file: 'person_lifting_weights_animated' },
  '🤸': { folder: 'Person cartwheeling', file: 'person_cartwheeling_animated' },
  '🏊': { folder: 'Person swimming', file: 'person_swimming_animated_default', hasDefault: true },
  '🚴': { folder: 'Person biking', file: 'person_biking_animated_default', hasDefault: true },
  '🧗': { folder: 'Person climbing', file: 'person_climbing_animated_default', hasDefault: true },
  '🤾': { folder: 'Person playing handball', file: 'person_playing_handball_animated_default', hasDefault: true },
  '🏌️': { folder: 'Person golfing', file: 'person_golfing_animated' },
  '🏌': { folder: 'Person golfing', file: 'person_golfing_animated' },
  '🏇': { folder: 'Horse racing', file: 'horse_racing_animated' },
  '🛹': { folder: 'Skateboard', file: 'skateboard_animated' },
  '🛷': { folder: 'Sled', file: 'sled_animated' },
  '🥌': { folder: 'Curling stone', file: 'curling_stone_animated' },
  
  // === COMMUNICATION & UI ===
  // '💬' Speech balloon - NO ANIMATED VERSION (use static 3D)
  '💭': { folder: 'Thought balloon', file: 'thought_balloon_animated' },
  '🗯️': { folder: 'Right anger bubble', file: 'right_anger_bubble_animated' },
  '🗯': { folder: 'Right anger bubble', file: 'right_anger_bubble_animated' },
  '📢': { folder: 'Loudspeaker', file: 'loudspeaker_animated' },
  '📣': { folder: 'Megaphone', file: 'megaphone_animated' },
  '📯': { folder: 'Postal horn', file: 'postal_horn_animated' },
  '🔕': { folder: 'Bell with slash', file: 'bell_with_slash_animated' },
  // '✅' Check mark button - NO ANIMATED VERSION (use static 3D)
  '❌': { folder: 'Cross mark', file: 'cross_mark_animated' },
  '❓': { folder: 'Red question mark', file: 'red_question_mark_animated' },
  '❔': { folder: 'White question mark', file: 'white_question_mark_animated' },
  '❗': { folder: 'Red exclamation mark', file: 'red_exclamation_mark_animated' },
  '❕': { folder: 'White exclamation mark', file: 'white_exclamation_mark_animated' },
  '‼️': { folder: 'Double exclamation mark', file: 'double_exclamation_mark_animated' },
  '‼': { folder: 'Double exclamation mark', file: 'double_exclamation_mark_animated' },
  '⁉️': { folder: 'Exclamation question mark', file: 'exclamation_question_mark_animated' },
  '⁉': { folder: 'Exclamation question mark', file: 'exclamation_question_mark_animated' },
  '💤': { folder: 'ZZZ', file: 'zzz_animated' },
  '💢': { folder: 'Anger symbol', file: 'anger_symbol_animated' },
  '💣': { folder: 'Bomb', file: 'bomb_animated' },
  '💥': { folder: 'Collision', file: 'collision_animated' },
  '🕳️': { folder: 'Hole', file: 'hole_animated' },
  '🕳': { folder: 'Hole', file: 'hole_animated' },
  '💝': { folder: 'Heart with ribbon', file: 'heart_with_ribbon_animated' },
  '💖': { folder: 'Sparkling heart', file: 'sparkling_heart_animated' },
  '💗': { folder: 'Growing heart', file: 'growing_heart_animated' },
  '💓': { folder: 'Beating heart', file: 'beating_heart_animated' },
  '💞': { folder: 'Revolving hearts', file: 'revolving_hearts_animated' },
  '💕': { folder: 'Two hearts', file: 'two_hearts_animated' },
  '💟': { folder: 'Heart decoration', file: 'heart_decoration_animated' },
  '💔': { folder: 'Broken heart', file: 'broken_heart_animated' },
  '🩷': { folder: 'Pink heart', file: 'pink_heart_animated' },
  '🧡': { folder: 'Orange heart', file: 'orange_heart_animated' },
  '💛': { folder: 'Yellow heart', file: 'yellow_heart_animated' },
  '💚': { folder: 'Green heart', file: 'green_heart_animated' },
  '💙': { folder: 'Blue heart', file: 'blue_heart_animated' },
  '🩵': { folder: 'Light blue heart', file: 'light_blue_heart_animated' },
  '💜': { folder: 'Purple heart', file: 'purple_heart_animated' },
  '🖤': { folder: 'Black heart', file: 'black_heart_animated' },
  '🩶': { folder: 'Grey heart', file: 'grey_heart_animated' },
  '🤍': { folder: 'White heart', file: 'white_heart_animated' },
  '🤎': { folder: 'Brown heart', file: 'brown_heart_animated' },
  
  // === SYMBOLS & ARROWS ===
  // '🔄' Counterclockwise arrows button - NO ANIMATED VERSION (use static 3D)
  '🔃': { folder: 'Clockwise vertical arrows', file: 'clockwise_vertical_arrows_animated' },
  '🔁': { folder: 'Repeat button', file: 'repeat_button_animated' },
  '🔂': { folder: 'Repeat single button', file: 'repeat_single_button_animated' },
  '▶️': { folder: 'Play button', file: 'play_button_animated' },
  '▶': { folder: 'Play button', file: 'play_button_animated' },
  '⏸️': { folder: 'Pause button', file: 'pause_button_animated' },
  '⏸': { folder: 'Pause button', file: 'pause_button_animated' },
  '⏹️': { folder: 'Stop button', file: 'stop_button_animated' },
  '⏹': { folder: 'Stop button', file: 'stop_button_animated' },
  '⏺️': { folder: 'Record button', file: 'record_button_animated' },
  '⏺': { folder: 'Record button', file: 'record_button_animated' },
  '⏏️': { folder: 'Eject button', file: 'eject_button_animated' },
  '⏏': { folder: 'Eject button', file: 'eject_button_animated' },
  '⏭️': { folder: 'Next track button', file: 'next_track_button_animated' },
  '⏭': { folder: 'Next track button', file: 'next_track_button_animated' },
  '⏮️': { folder: 'Last track button', file: 'last_track_button_animated' },
  '⏮': { folder: 'Last track button', file: 'last_track_button_animated' },
  '⏩': { folder: 'Fast-forward button', file: 'fast-forward_button_animated' },
  '⏪': { folder: 'Fast reverse button', file: 'fast_reverse_button_animated' },
  '🔀': { folder: 'Shuffle tracks button', file: 'shuffle_tracks_button_animated' },
  '➡️': { folder: 'Right arrow', file: 'right_arrow_animated' },
  '➡': { folder: 'Right arrow', file: 'right_arrow_animated' },
  '⬅️': { folder: 'Left arrow', file: 'left_arrow_animated' },
  '⬅': { folder: 'Left arrow', file: 'left_arrow_animated' },
  // '⬆️' Up arrow - NO ANIMATED VERSION (use static 3D)
  // '⬆' Up arrow - NO ANIMATED VERSION (use static 3D)
  '⬇️': { folder: 'Down arrow', file: 'down_arrow_animated' },
  '⬇': { folder: 'Down arrow', file: 'down_arrow_animated' },
  '↗️': { folder: 'Up-right arrow', file: 'up-right_arrow_animated' },
  '↗': { folder: 'Up-right arrow', file: 'up-right_arrow_animated' },
  '↘️': { folder: 'Down-right arrow', file: 'down-right_arrow_animated' },
  '↘': { folder: 'Down-right arrow', file: 'down-right_arrow_animated' },
  '↙️': { folder: 'Down-left arrow', file: 'down-left_arrow_animated' },
  '↙': { folder: 'Down-left arrow', file: 'down-left_arrow_animated' },
  '↖️': { folder: 'Up-left arrow', file: 'up-left_arrow_animated' },
  '↖': { folder: 'Up-left arrow', file: 'up-left_arrow_animated' },
  '↕️': { folder: 'Up-down arrow', file: 'up-down_arrow_animated' },
  '↕': { folder: 'Up-down arrow', file: 'up-down_arrow_animated' },
  '↔️': { folder: 'Left-right arrow', file: 'left-right_arrow_animated' },
  '↔': { folder: 'Left-right arrow', file: 'left-right_arrow_animated' },
  '↩️': { folder: 'Right arrow curving left', file: 'right_arrow_curving_left_animated' },
  '↩': { folder: 'Right arrow curving left', file: 'right_arrow_curving_left_animated' },
  '↪️': { folder: 'Left arrow curving right', file: 'left_arrow_curving_right_animated' },
  '↪': { folder: 'Left arrow curving right', file: 'left_arrow_curving_right_animated' },
  '⤴️': { folder: 'Right arrow curving up', file: 'right_arrow_curving_up_animated' },
  '⤴': { folder: 'Right arrow curving up', file: 'right_arrow_curving_up_animated' },
  '⤵️': { folder: 'Right arrow curving down', file: 'right_arrow_curving_down_animated' },
  '⤵': { folder: 'Right arrow curving down', file: 'right_arrow_curving_down_animated' },
  '🔼': { folder: 'Upwards button', file: 'upwards_button_animated' },
  '🔽': { folder: 'Downwards button', file: 'downwards_button_animated' },
  // '➕' Plus - NO ANIMATED VERSION (use static 3D)
  '➖': { folder: 'Minus', file: 'minus_animated' },
  '➗': { folder: 'Divide', file: 'divide_animated' },
  '✖️': { folder: 'Multiply', file: 'multiply_animated' },
  '✖': { folder: 'Multiply', file: 'multiply_animated' },
  '♾️': { folder: 'Infinity', file: 'infinity_animated' },
  '♾': { folder: 'Infinity', file: 'infinity_animated' },
  
  // === LOCKS & SECURITY ===
  '🔒': { folder: 'Locked', file: 'locked_animated' },
  '🔓': { folder: 'Unlocked', file: 'unlocked_animated' },
  // '🔐' Locked with key - NO ANIMATED VERSION (use static 3D)
  '🔑': { folder: 'Key', file: 'key_animated' },
  '🗝️': { folder: 'Old key', file: 'old_key_animated' },
  '🗝': { folder: 'Old key', file: 'old_key_animated' },
  
  // === MISC OBJECTS ===
  // '📅' Calendar - NO ANIMATED VERSION (use static 3D)
  '📆': { folder: 'Tear-off calendar', file: 'tear-off_calendar_animated' },
  '🗓️': { folder: 'Spiral calendar', file: 'spiral_calendar_animated' },
  '🗓': { folder: 'Spiral calendar', file: 'spiral_calendar_animated' },
  // '📚' Books - NO ANIMATED VERSION (use static 3D)
  '📖': { folder: 'Open book', file: 'open_book_animated' },
  '📕': { folder: 'Closed book', file: 'closed_book_animated' },
  '📗': { folder: 'Green book', file: 'green_book_animated' },
  '📘': { folder: 'Blue book', file: 'blue_book_animated' },
  '📙': { folder: 'Orange book', file: 'orange_book_animated' },
  '📓': { folder: 'Notebook', file: 'notebook_animated' },
  '📔': { folder: 'Notebook with decorative cover', file: 'notebook_with_decorative_cover_animated' },
  '📒': { folder: 'Ledger', file: 'ledger_animated' },
  '📃': { folder: 'Page with curl', file: 'page_with_curl_animated' },
  '📜': { folder: 'Scroll', file: 'scroll_animated' },
  '📄': { folder: 'Page facing up', file: 'page_facing_up_animated' },
  '📑': { folder: 'Bookmark tabs', file: 'bookmark_tabs_animated' },
  '🔖': { folder: 'Bookmark', file: 'bookmark_animated' },
  '🏷️': { folder: 'Label', file: 'label_animated' },
  '🏷': { folder: 'Label', file: 'label_animated' },
  '📝': { folder: 'Memo', file: 'memo_animated' },
  '✏️': { folder: 'Pencil', file: 'pencil_animated' },
  '✏': { folder: 'Pencil', file: 'pencil_animated' },
  '🖊️': { folder: 'Pen', file: 'pen_animated' },
  '🖊': { folder: 'Pen', file: 'pen_animated' },
  '🖋️': { folder: 'Fountain pen', file: 'fountain_pen_animated' },
  '🖋': { folder: 'Fountain pen', file: 'fountain_pen_animated' },
  '🖌️': { folder: 'Paintbrush', file: 'paintbrush_animated' },
  '🖌': { folder: 'Paintbrush', file: 'paintbrush_animated' },
  '🖍️': { folder: 'Crayon', file: 'crayon_animated' },
  '🖍': { folder: 'Crayon', file: 'crayon_animated' },
  // '📋' Clipboard - NO ANIMATED VERSION (use static 3D)
  '📁': { folder: 'File folder', file: 'file_folder_animated' },
  '📂': { folder: 'Open file folder', file: 'open_file_folder_animated' },
  '🗂️': { folder: 'Card index dividers', file: 'card_index_dividers_animated' },
  '🗂': { folder: 'Card index dividers', file: 'card_index_dividers_animated' },
  // '📰' Newspaper - NO ANIMATED VERSION (use static 3D)
  '🗞️': { folder: 'Rolled-up newspaper', file: 'rolled-up_newspaper_animated' },
  '🗞': { folder: 'Rolled-up newspaper', file: 'rolled-up_newspaper_animated' },
  '📦': { folder: 'Package', file: 'package_animated' },
  '📫': { folder: 'Closed mailbox with raised flag', file: 'closed_mailbox_with_raised_flag_animated' },
  '📪': { folder: 'Closed mailbox with lowered flag', file: 'closed_mailbox_with_lowered_flag_animated' },
  '📬': { folder: 'Open mailbox with raised flag', file: 'open_mailbox_with_raised_flag_animated' },
  '📭': { folder: 'Open mailbox with lowered flag', file: 'open_mailbox_with_lowered_flag_animated' },
  '📮': { folder: 'Postbox', file: 'postbox_animated' },
  '🗳️': { folder: 'Ballot box with ballot', file: 'ballot_box_with_ballot_animated' },
  '🗳': { folder: 'Ballot box with ballot', file: 'ballot_box_with_ballot_animated' },
  '📤': { folder: 'Outbox tray', file: 'outbox_tray_animated' },
  '📥': { folder: 'Inbox tray', file: 'inbox_tray_animated' },
  '📧': { folder: 'E-mail', file: 'e-mail_animated' },
  '📨': { folder: 'Incoming envelope', file: 'incoming_envelope_animated' },
  '📩': { folder: 'Envelope with arrow', file: 'envelope_with_arrow_animated' },
  '✉️': { folder: 'Envelope', file: 'envelope_animated' },
  '✉': { folder: 'Envelope', file: 'envelope_animated' },
  '📊': { folder: 'Bar chart', file: 'bar_chart_animated' },
  // '📈' Chart increasing - NO ANIMATED VERSION (use static 3D)
  '📉': { folder: 'Chart decreasing', file: 'chart_decreasing_animated' },
  '🔍': { folder: 'Magnifying glass tilted left', file: 'magnifying_glass_tilted_left_animated' },
  '🔎': { folder: 'Magnifying glass tilted right', file: 'magnifying_glass_tilted_right_animated' },
  '🔗': { folder: 'Link', file: 'link_animated' },
  '📎': { folder: 'Paperclip', file: 'paperclip_animated' },
  '🖇️': { folder: 'Linked paperclips', file: 'linked_paperclips_animated' },
  '🖇': { folder: 'Linked paperclips', file: 'linked_paperclips_animated' },
  '✂️': { folder: 'Scissors', file: 'scissors_animated' },
  '✂': { folder: 'Scissors', file: 'scissors_animated' },
  '📌': { folder: 'Pushpin', file: 'pushpin_animated' },
  '📍': { folder: 'Round pushpin', file: 'round_pushpin_animated' },
  '🚩': { folder: 'Triangular flag', file: 'triangular_flag_animated' },
  '🏳️': { folder: 'White flag', file: 'white_flag_animated' },
  '🏳': { folder: 'White flag', file: 'white_flag_animated' },
  '🏴': { folder: 'Black flag', file: 'black_flag_animated' },
  '🏁': { folder: 'Chequered flag', file: 'chequered_flag_animated' },
  '🎨': { folder: 'Artist palette', file: 'artist_palette_animated' },
  '🗑️': { folder: 'Wastebasket', file: 'wastebasket_animated' },
  '🗑': { folder: 'Wastebasket', file: 'wastebasket_animated' },
  '🖼️': { folder: 'Framed picture', file: 'framed_picture_animated' },
  '🖼': { folder: 'Framed picture', file: 'framed_picture_animated' },
  '🪞': { folder: 'Mirror', file: 'mirror_animated' },
  '🪟': { folder: 'Window', file: 'window_animated' },
  '🛏️': { folder: 'Bed', file: 'bed_animated' },
  '🛏': { folder: 'Bed', file: 'bed_animated' },
  '🛋️': { folder: 'Couch and lamp', file: 'couch_and_lamp_animated' },
  '🛋': { folder: 'Couch and lamp', file: 'couch_and_lamp_animated' },
  '🪑': { folder: 'Chair', file: 'chair_animated' },
  '🚽': { folder: 'Toilet', file: 'toilet_animated' },
  '🚿': { folder: 'Shower', file: 'shower_animated' },
  '🛁': { folder: 'Bathtub', file: 'bathtub_animated' },
  '🪥': { folder: 'Toothbrush', file: 'toothbrush_animated' },
  '🧴': { folder: 'Lotion bottle', file: 'lotion_bottle_animated' },
  '🧷': { folder: 'Safety pin', file: 'safety_pin_animated' },
  '🧹': { folder: 'Broom', file: 'broom_animated' },
  '🧺': { folder: 'Basket', file: 'basket_animated' },
  '🧻': { folder: 'Roll of paper', file: 'roll_of_paper_animated' },
  '🪣': { folder: 'Bucket', file: 'bucket_animated' },
  '🧼': { folder: 'Soap', file: 'soap_animated' },
  '🫧': { folder: 'Bubbles', file: 'bubbles_animated' },
  '🪤': { folder: 'Mouse trap', file: 'mouse_trap_animated' },
  '🚪': { folder: 'Door', file: 'door_animated' },
  '🛗': { folder: 'Elevator', file: 'elevator_animated' },
  '🪜': { folder: 'Ladder', file: 'ladder_animated' },
  '⚠️': { folder: 'Warning', file: 'warning_animated' },
  '⚠': { folder: 'Warning', file: 'warning_animated' },
  
  // === TRANSPORT ===
  '🚗': { folder: 'Automobile', file: 'automobile_animated' },
  '🚕': { folder: 'Taxi', file: 'taxi_animated' },
  '🚙': { folder: 'Sport utility vehicle', file: 'sport_utility_vehicle_animated' },
  '🚌': { folder: 'Bus', file: 'bus_animated' },
  '🚎': { folder: 'Trolleybus', file: 'trolleybus_animated' },
  '🏎️': { folder: 'Racing car', file: 'racing_car_animated' },
  '🏎': { folder: 'Racing car', file: 'racing_car_animated' },
  '🚓': { folder: 'Police car', file: 'police_car_animated' },
  '🚑': { folder: 'Ambulance', file: 'ambulance_animated' },
  '🚒': { folder: 'Fire engine', file: 'fire_engine_animated' },
  '🚐': { folder: 'Minibus', file: 'minibus_animated' },
  '🛻': { folder: 'Pickup truck', file: 'pickup_truck_animated' },
  '🚚': { folder: 'Delivery truck', file: 'delivery_truck_animated' },
  '🚛': { folder: 'Articulated lorry', file: 'articulated_lorry_animated' },
  '🚜': { folder: 'Tractor', file: 'tractor_animated' },
  '🛵': { folder: 'Motor scooter', file: 'motor_scooter_animated' },
  '🏍️': { folder: 'Motorcycle', file: 'motorcycle_animated' },
  '🏍': { folder: 'Motorcycle', file: 'motorcycle_animated' },
  '🛺': { folder: 'Auto rickshaw', file: 'auto_rickshaw_animated' },
  '🚲': { folder: 'Bicycle', file: 'bicycle_animated' },
  '🛴': { folder: 'Kick scooter', file: 'kick_scooter_animated' },
  '🛼': { folder: 'Roller skate', file: 'roller_skate_animated' },
  '🚏': { folder: 'Bus stop', file: 'bus_stop_animated' },
  '🛤️': { folder: 'Railway track', file: 'railway_track_animated' },
  '🛤': { folder: 'Railway track', file: 'railway_track_animated' },
  '🚃': { folder: 'Railway car', file: 'railway_car_animated' },
  '🚋': { folder: 'Tram car', file: 'tram_car_animated' },
  '🚞': { folder: 'Mountain railway', file: 'mountain_railway_animated' },
  '🚝': { folder: 'Monorail', file: 'monorail_animated' },
  '🚄': { folder: 'High-speed train', file: 'high-speed_train_animated' },
  '🚅': { folder: 'Bullet train', file: 'bullet_train_animated' },
  '🚈': { folder: 'Light rail', file: 'light_rail_animated' },
  '🚂': { folder: 'Locomotive', file: 'locomotive_animated' },
  '🚆': { folder: 'Train', file: 'train_animated' },
  '🚇': { folder: 'Metro', file: 'metro_animated' },
  '🚊': { folder: 'Tram', file: 'tram_animated' },
  '🚉': { folder: 'Station', file: 'station_animated' },
  '✈️': { folder: 'Airplane', file: 'airplane_animated' },
  '✈': { folder: 'Airplane', file: 'airplane_animated' },
  '🛫': { folder: 'Airplane departure', file: 'airplane_departure_animated' },
  '🛬': { folder: 'Airplane arrival', file: 'airplane_arrival_animated' },
  '🛩️': { folder: 'Small airplane', file: 'small_airplane_animated' },
  '🛩': { folder: 'Small airplane', file: 'small_airplane_animated' },
  '💺': { folder: 'Seat', file: 'seat_animated' },
  '🛰️': { folder: 'Satellite', file: 'satellite_animated' },
  '🛰': { folder: 'Satellite', file: 'satellite_animated' },
  '🚁': { folder: 'Helicopter', file: 'helicopter_animated' },
  '🛸': { folder: 'Flying saucer', file: 'flying_saucer_animated' },
  '🛶': { folder: 'Canoe', file: 'canoe_animated' },
  '⛵': { folder: 'Sailboat', file: 'sailboat_animated' },
  '🚤': { folder: 'Speedboat', file: 'speedboat_animated' },
  '🛥️': { folder: 'Motor boat', file: 'motor_boat_animated' },
  '🛥': { folder: 'Motor boat', file: 'motor_boat_animated' },
  '🛳️': { folder: 'Passenger ship', file: 'passenger_ship_animated' },
  '🛳': { folder: 'Passenger ship', file: 'passenger_ship_animated' },
  '⛴️': { folder: 'Ferry', file: 'ferry_animated' },
  '⛴': { folder: 'Ferry', file: 'ferry_animated' },
  '🚢': { folder: 'Ship', file: 'ship_animated' },
  '⚓': { folder: 'Anchor', file: 'anchor_animated' },
  '🪝': { folder: 'Hook', file: 'hook_animated' },
  '⛽': { folder: 'Fuel pump', file: 'fuel_pump_animated' },
  '🚧': { folder: 'Construction', file: 'construction_animated' },
  '🚦': { folder: 'Vertical traffic light', file: 'vertical_traffic_light_animated' },
  '🚥': { folder: 'Horizontal traffic light', file: 'horizontal_traffic_light_animated' },
  '🗺️': { folder: 'World map', file: 'world_map_animated' },
  '🗺': { folder: 'World map', file: 'world_map_animated' },
  '🗿': { folder: 'Moai', file: 'moai_animated' },
  '🗽': { folder: 'Statue of Liberty', file: 'statue_of_liberty_animated' },
  '🗼': { folder: 'Tokyo tower', file: 'tokyo_tower_animated' },
  '🏰': { folder: 'Castle', file: 'castle_animated' },
  '🏯': { folder: 'Japanese castle', file: 'japanese_castle_animated' },
  '🏟️': { folder: 'Stadium', file: 'stadium_animated' },
  '🏟': { folder: 'Stadium', file: 'stadium_animated' },
  '🎡': { folder: 'Ferris wheel', file: 'ferris_wheel_animated' },
  '🎢': { folder: 'Roller coaster', file: 'roller_coaster_animated' },
  '🎠': { folder: 'Carousel horse', file: 'carousel_horse_animated' },
  '⛲': { folder: 'Fountain', file: 'fountain_animated' },
  '⛱️': { folder: 'Umbrella on ground', file: 'umbrella_on_ground_animated' },
  '⛱': { folder: 'Umbrella on ground', file: 'umbrella_on_ground_animated' },
  '🏖️': { folder: 'Beach with umbrella', file: 'beach_with_umbrella_animated' },
  '🏖': { folder: 'Beach with umbrella', file: 'beach_with_umbrella_animated' },
  // '🏝️' Desert island - NO ANIMATED VERSION (use static 3D)
  // '🏝' Desert island - NO ANIMATED VERSION (use static 3D)
  '🏜️': { folder: 'Desert', file: 'desert_animated' },
  '🏜': { folder: 'Desert', file: 'desert_animated' },
  '🌋': { folder: 'Volcano', file: 'volcano_animated' },
  '⛰️': { folder: 'Mountain', file: 'mountain_animated' },
  '⛰': { folder: 'Mountain', file: 'mountain_animated' },
  '🏔️': { folder: 'Snow-capped mountain', file: 'snow-capped_mountain_animated' },
  '🏔': { folder: 'Snow-capped mountain', file: 'snow-capped_mountain_animated' },
  '🗻': { folder: 'Mount Fuji', file: 'mount_fuji_animated' },
  '🏕️': { folder: 'Camping', file: 'camping_animated' },
  '🏕': { folder: 'Camping', file: 'camping_animated' },
  '⛺': { folder: 'Tent', file: 'tent_animated' },
  '🏪': { folder: 'Convenience store', file: 'convenience_store_animated' },
  '🏬': { folder: 'Department store', file: 'department_store_animated' },
  '🏭': { folder: 'Factory', file: 'factory_animated' },
  '🏢': { folder: 'Office building', file: 'office_building_animated' },
  '🏣': { folder: 'Japanese post office', file: 'japanese_post_office_animated' },
  '🏤': { folder: 'Post office', file: 'post_office_animated' },
  '🏥': { folder: 'Hospital', file: 'hospital_animated' },
  '🏦': { folder: 'Bank', file: 'bank_animated' },
  '🏨': { folder: 'Hotel', file: 'hotel_animated' },
  '🏩': { folder: 'Love hotel', file: 'love_hotel_animated' },
  '🏫': { folder: 'School', file: 'school_animated' },
  '💒': { folder: 'Wedding', file: 'wedding_animated' },
  '🏛️': { folder: 'Classical building', file: 'classical_building_animated' },
  '🏛': { folder: 'Classical building', file: 'classical_building_animated' },
  '⛪': { folder: 'Church', file: 'church_animated' },
  '🕌': { folder: 'Mosque', file: 'mosque_animated' },
  '🛕': { folder: 'Hindu temple', file: 'hindu_temple_animated' },
  '🕍': { folder: 'Synagogue', file: 'synagogue_animated' },
  '⛩️': { folder: 'Shinto shrine', file: 'shinto_shrine_animated' },
  '⛩': { folder: 'Shinto shrine', file: 'shinto_shrine_animated' },
  '🕋': { folder: 'Kaaba', file: 'kaaba_animated' },
}

/**
 * Get the Fluent Emoji CDN URL for a given emoji character
 * @param emoji - The emoji character (e.g., '🔥')
 * @returns The full CDN URL or null if not mapped
 */
export function getFluentEmojiUrl(emoji: string): string | null {
  const path = EMOJI_MAP[emoji]
  if (!path) return null
  return `${FLUENT_EMOJI_CDN}/${encodeURIComponent(path.split('/')[0])}/${path.split('/').slice(1).join('/')}`
}

/**
 * Check if an emoji has a Fluent Emoji mapping
 */
export function hasFluentEmoji(emoji: string): boolean {
  return emoji in EMOJI_MAP
}

/**
 * Get the Animated Fluent Emoji CDN URL for a given emoji character
 * @param emoji - The emoji character (e.g., '🔥')
 * @returns The full CDN URL or null if not mapped
 */
export function getAnimatedFluentEmojiUrl(emoji: string): string | null {
  const config = ANIMATED_EMOJI_MAP[emoji]
  if (!config) return null
  
  const { folder, file, hasDefault } = config
  // Path format: {Folder}/[Default/]animated/{file}.png
  // e.g., Fire/animated/fire_animated.png or Person running/Default/animated/person_running_animated_default.png
  // Folder names with spaces need to be URL encoded
  const encodedFolder = encodeURIComponent(folder)
  const path = hasDefault 
    ? `${encodedFolder}/Default/animated/${file}.png`
    : `${encodedFolder}/animated/${file}.png`
  return `${FLUENT_EMOJI_ANIMATED_CDN}/${path}`
}

/**
 * Check if an emoji has an Animated Fluent Emoji mapping
 */
export function hasAnimatedFluentEmoji(emoji: string): boolean {
  return emoji in ANIMATED_EMOJI_MAP
}

